<template>
  <el-dialog
    :title="'周报详情 - ' + weeklyReportData.userName"
    :visible.sync="weeklyReportViewProps.visible"
    :close-on-click-modal="false"
    class="topDialog weeklyReportViewDialog"
    @close="closeDialog()"
    :close-on-press-escape="false">

    <div class="weeklyBox">
        <el-row :gutter="20">
          <el-col :span="18">
             <p style="font-size: 14px;margin-bottom: 20px;font-weight: 600;">一周工作小结</p>
            <el-input type="textarea" :rows="5" v-model="weeklyReportData.description" readonly></el-input>
          </el-col>
          <el-col :span="6">
             <p style="font-size: 14px;margin-bottom: 20px;font-weight: 600;">附件</p>
            <ul class="el-upload-list el-upload-list--text">
               <li v-for="item in weeklyReportData.attachedFiles" :key="item.url" :label="item.name" class="el-upload-list__item is-success">
                 <a href="javascript:void(0)" class="el-upload-list__item-name" @click="clickAttachedFile(item.url)">
                   <i class="el-icon-document"></i>
                   {{item.name}}
                   </a>
               </li>
            </ul>
          </el-col>
        </el-row>
      </div>

    <div>
        <el-tabs v-model="activeName">
        <el-tab-pane label="周报视图" name="weeklyReportDetailViewTab">
            <weeklyReportView_Detail ref="weeklyReportView_Detail"></weeklyReportView_Detail>
          <!--   :currentWeekInfo="currentWeekDayInfo" -->
        </el-tab-pane>
        <el-tab-pane label="工时视图" name="weeklyReportSpentTimeViewTab">
          <weeklyReportView_SpentTime ref="weeklyReportView_SpentTime"></weeklyReportView_SpentTime>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="weeklyReportViewProps.visible=false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { dateFtt } from "@/utils/auth.js";
import weeklyReportView_Detail from "./weeklyReportView_Detail"
import weeklyReportView_SpentTime from "./weeklyReportView_SpentTime"
export default {
  name: "weeklyReportView",
  props: ["weeklyReportViewProps", "currentLineInfo"],
  components:{weeklyReportView_Detail,weeklyReportView_SpentTime},
  data() {
    return {
      activeName:"weeklyReportDetailViewTab",
      getWeeklyReportByUserArgs:{},
      // 记录每周周报的id和备注信息
      weeklyReportData: {
        id: "",
        userName:"",
        description: "",
        attachedFiles:[]
      },
    }
  },
  mounted() {
  },
  methods: {

    showById(id){
        this.weeklyReportViewProps.visible = true;
        this.getWeeklyPort(id);
    },

    showByUser(query){
        this.weeklyReportViewProps.visible = true;
        this.getWeeklyPortByUser(query);
    },
 
    getWeeklyPort(id) 
    {
            if(this.$refs.weeklyReportView_Detail!=null)
            {
               this.$refs.weeklyReportView_Detail.clearData();
            }
            if(this.$refs.weeklyReportView_SpentTime!=null)
            {
              this.$refs.weeklyReportView_SpentTime.clearData();
            }

      this.$weeklyReportApi.getWeeklyReport(id)
        .then(res => {
          if (res.data.successful) {
            this.weeklyReportData = res.data.data;
            if(this.$refs.weeklyReportView_Detail!=null)
            {
              this.$refs.weeklyReportView_Detail.loadWeeklyReportData(res.data.data);
            }
            if(this.$refs.weeklyReportView_SpentTime!=null)
            {
              this.$refs.weeklyReportView_SpentTime.loadWeeklyReportData(res.data.data);
            }
          }
        });
    },
    getWeeklyPortByUser(query) 
    {
          if(this.$refs.weeklyReportView_Detail!=null)
            {
               this.$refs.weeklyReportView_Detail.clearData();
            }
            if(this.$refs.weeklyReportView_SpentTime!=null)
            {
              this.$refs.weeklyReportView_SpentTime.clearData();
            }

      this.$weeklyReportApi.getWeeklyReportByUser(query)
        .then(res => {
          if (res.data.successful) {
            this.weeklyReportData = res.data.data;
            if(this.$refs.weeklyReportView_Detail!=null)
            {
              this.$refs.weeklyReportView_Detail.loadWeeklyReportData(res.data.data);
            }
            if(this.$refs.weeklyReportView_SpentTime!=null)
            {
              this.$refs.weeklyReportView_SpentTime.loadWeeklyReportData(res.data.data);
            }
          }
         })
    },
    closeDialog() {
      this.weeklyReportViewProps.visible = false;
      this.activeName = "weeklyReportDetailViewTab";
      document.getElementsByClassName('el-dialog__body')[0].scrollTop = 0;
    },
     clickAttachedFile(url){
      window.open(window.Glob.BASE_URL + url); 
    }
  }
};
</script>

<style  rel="stylesheet/scss" lang="scss">

.weeklyBox {
  margin-top: 15px;
  margin-bottom: 10px;
  padding: 10px;
  padding-right: 0;
  // box-shadow: 0px 0px 0px 2px #f5f5f5;
  // box-shadow: inset 0px 0px 0px 4px #f5f5f5;
}

.weeklyReportViewDialog .el-dialog{
    top: 2vh !important;
    bottom: 2vh !important;
    left: 10% !important;
    right: 10% !important;
    width: 80% !important;
}

</style>


// WEBPACK FOOTER //
// src/views/common/weeklyReportView.vue